import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.constructor.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "card-wrapper"
};
var _hoisted_2 = {
  class: "info-row name-and-picture-wrapper"
};
var _hoisted_3 = {
  class: "names-wrapper"
};
var _hoisted_4 = {
  class: "category-name"
};
var _hoisted_5 = {
  key: 0,
  class: "category-name price-name"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  key: 0,
  class: "not-available"
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

var _hoisted_9 = {
  class: "unavailalbe-or-soldout"
};
var _hoisted_10 = {
  class: "tickets-sold"
};

var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

var _hoisted_12 = {
  key: 0,
  class: "info-row dates-wrapper"
};
var _hoisted_13 = {
  class: "price-and-availabilities-wrapper"
};
var _hoisted_14 = {
  class: "info-row"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = {
  key: 0,
  class: "availabilities-wrapper"
};

var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-border"
}, null, -1);

var _hoisted_18 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SeatingPlan = _resolveComponent("SeatingPlan");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    "data-cy": "product-card",
    class: _normalizeClass(["pc-card", {
      'pointer-cursor': _ctx.getCurrentAvailability
    }]),
    onMousedown: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.refreshPeriod && _ctx.refreshPeriod.apply(_ctx, arguments);
    }),
    onMouseup: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.stopPeriod && _ctx.stopPeriod.apply(_ctx, arguments);
    }),
    onTouchstart: _cache[2] || (_cache[2] = //@ts-ignore
    function () {
      return _ctx.refreshPeriod && _ctx.refreshPeriod.apply(_ctx, arguments);
    }),
    onTouchend: _cache[3] || (_cache[3] = //@ts-ignore
    function () {
      return _ctx.stopPeriod && _ctx.stopPeriod.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.product.categoryName), 1), _ctx.product.prices && _ctx.hasOnePrice && !_ctx.noOptionRetail ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.product.prices[0].retail && _ctx.product.prices[0].retail.length && _ctx.product.prices[0].retail[0].type !== _ctx.RetailOptionType.Default_Retail_Option ? _ctx.product.prices[0].retail[0].name : !_ctx.isSeatingTicket ? _ctx.product.prices[0].name : ""), 1)) : _createCommentVNode("", true)]), _createElementVNode("img", {
    src: _ctx.productPicture
  }, null, 8, _hoisted_6)]), _createElementVNode("div", {
    class: _normalizeClass({
      relative: ((!_ctx.getCurrentAvailability || _ctx.getCurrentAvailability < 0) && !_ctx.sellOnSoldOut(_ctx.product.prices, _ctx.product.type)
      /*&&
      !sharedStocksWithOverbooking*/
      || !_ctx.isSalesPeriod(_ctx.product)) && !_ctx.isSeatingTicket
    })
  }, [((!_ctx.getCurrentAvailability || _ctx.getCurrentAvailability < 0) && !_ctx.sellOnSoldOut(_ctx.product.prices, _ctx.product.type) || !_ctx.isSalesPeriod(_ctx.product)) && !_ctx.isSeatingTicket ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.isUnavailbleOrSoldOutText(_ctx.product)), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.product.booked) + " " + _toDisplayString(_ctx.isRetail ? _ctx.$t("field.sold") : _ctx.$t("field.tickets-sold")) + "!", 1), _hoisted_11])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass({
      blurry: ((!_ctx.getCurrentAvailability || _ctx.getCurrentAvailability < 0) && !_ctx.sellOnSoldOut(_ctx.product.prices, _ctx.product.type)
      /*&&
      !sharedStocksWithOverbooking*/
      || !_ctx.isSalesPeriod(_ctx.product)) && !_ctx.isSeatingTicket,
      'below-part-wrapper': _ctx.isRetail
    })
  }, [!_ctx.isRetail ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.formatDateTime(String(_ctx.product.startDateTime))), 1)]), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.formatDateTime(String(_ctx.product.endDateTime))), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("p", null, [_createTextVNode(_toDisplayString(_ctx.$t("common.from-semicolon")) + " ", 1), _createElementVNode("strong", null, _toDisplayString(_ctx.product.currency) + " " + _toDisplayString(Math.min.apply(0, _ctx.pricesArray || [0])), 1)]), !Number.isInteger(_ctx.product.booked) ? (_openBlock(), _createElementBlock("p", _hoisted_15, [_createElementVNode("strong", null, _toDisplayString(_ctx.getCurrentAvailability), 1), _createTextVNode(" " + _toDisplayString(_ctx.isRetail ? _ctx.$t("pcselect.left") : _ctx.$t("pcselect.tickets-left")), 1)])) : _createCommentVNode("", true)]), Number.isInteger(_ctx.product.booked) ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.getCurrentAvailability), 1), _createTextVNode(" " + _toDisplayString(_ctx.isRetail ? _ctx.$t("pcselect.left") : _ctx.$t("pcselect.tickets-left")), 1)])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.product.booked), 1), _createTextVNode(" " + _toDisplayString(_ctx.isRetail ? _ctx.$t("field.sold") : _ctx.$t("field.tickets-sold")), 1)])])])) : _createCommentVNode("", true)])], 2)], 2), _hoisted_17])], 34), _ctx.showSeatingChart ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_SeatingPlan, {
    onClosingModal: _ctx.updateShowSeatingChart,
    product: _ctx.seatingDataToChartComponent
  }, null, 8, ["onClosingModal", "product"])])) : _createCommentVNode("", true)], 64);
}